export default "__VITE_ASSET__CYFB0fR6__";